<template>
  <div>
    <div class="content-header">
      <div class="left"><span class="title">打印统计</span></div>
      <div class="right"></div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon type="md-alert" size="20" color="#2d8cf0" style="margin-right: 10px" />
      <div>
        <div>1、打印统计指设备某一段时间产生的印量；</div>
        <div>2、下列数据摘取设备原生计数器印张，已将所有纸型换算成A4单面进行统计；</div>
      </div>
    </div>
    <div class="filter-box">
      <div class="item_box">
        <span class="subtitle">统计角度:</span>
        <Select v-model="page.group" style="width: 220px" @on-change="handleSwitchAngle">
          <Option v-for="item in dataType" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>

        <!-- <span class="subtitle ml10" v-if="!agent.tp">合作伙伴:</span>
        <Select
          v-model="page.agent_id"
          style="width: 220px"
          v-if="!agent.tp"
          clearable
          filterable
        >
          <Option v-for="item in agentList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select> -->

        <span class="subtitle ml10" v-if="page.group === 'machine_id'"
          >&nbsp;&nbsp;&nbsp;序列号:</span
        >
        <Input
          v-model="pageInfo.search"
          class="input"
          placeholder="按照序列号搜索"
          clearable
          v-if="page.group === 'machine_id'"
        ></Input>
        <span class="subtitle ml10" v-if="page.group === 'company_id'">所属学校:</span>
        <Select
          v-model="pageInfo.id"
          style="width: 220px"
          clearable
          filterable
          v-if="page.group === 'company_id'"
        >
          <Option v-for="item in companyList" :value="item.id" :key="item.id">{{
            item.company_name
          }}</Option>
        </Select>

        <span class="subtitle ml10" v-if="page.group === 'site_id'">所属站点:</span>
        <Select
          v-model="pageInfo.id"
          style="width: 220px"
          clearable
          filterable
          v-if="page.group === 'site_id'"
        >
          <Option v-for="item in siteList" :value="item.id" :key="item.id">{{
            item.name
          }}</Option>
        </Select>

        <span class="subtitle ml10">设备品牌:</span>
        <Select v-model="pageInfo.brand" style="width: 220px" clearable multiple>
          <Option v-for="(item, index) in machineTypesGroup" :value="item" :key="index">{{
            item
          }}</Option>
        </Select>
      </div>

      <div class="item_box">
        <span class="subtitle">查询时间:</span>
        <DatePicker
          type="daterange"
          format="yyyy-MM-dd"
          placeholder="选择时间"
          style="width: 220px"
          @on-change="handleDateChange"
          v-model="showDate"
          class="select"
          :clearable="false"
        ></DatePicker>
        <RadioGroup
          type="button"
          style="margin-left: 10px"
          v-model="radio"
          @on-change="onChangeSelectData"
        >
          <Radio label="0">
            <span>昨&nbsp;&nbsp;日</span>
          </Radio>
          <Radio label="1">
            <span>本 月</span>
          </Radio>
          <Radio label="2">
            <span>上 月</span>
          </Radio>
        </RadioGroup>
        <Checkbox
          style="margin-left: 12px"
          v-model="pageInfo.is_del"
          v-if="page.group === 'machine_id'"
          >查询已删除设备</Checkbox
        >
      </div>
      <div class="bottom">
        <span class="btn-filter" @click="submit">筛选</span>
        <span class="btn" @click="reset">清空</span>

        <Poptip title="导出Excel" placement="right" trigger="hover">
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>

    <div style="position: relative">
      <Table size="small" :columns="columns" :data="data" :loading="tableLoading" />
      <div class="t-right" style="margin-top: 10px">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :current="pageInfo.p + 1"
          :total="total"
          :page-size-opts="pageSizeOpts"
          :page-size="10"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="tableLoading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
  </div>
</template>

<script>
function getMonthStart() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 注意：getMonth() 返回的月份是从0开始的，所以1月是0，2月是1，依此类推
  const firstDay = new Date(year, month, 1);
  return firstDay;
}
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
import { machineGroup, companyGroup, siteGroup } from "./cols";

export default {
  data() {
    return {
      dataType: [
        {
          value: "machine_id",
          label: "设备角度",
        },
        {
          value: "company_id",
          label: "学校角度",
        },
        {
          value: "site_id",
          label: "站点角度",
        },
      ],
      page: {
        l: 10,
        p: 0,
        start_time: "",
        end_time: "",
        brand: [],
        sn: "",
        agent_id: 0,
        site_id: 0,
        company_id: 0,
        group: "machine_id",
      },
      pageInfo: {
        l: 10,
        p: 0,
        search: "",
        brand: [],
        id: 0,
        is_del: 0,
      },
      showDate: [],
      agentList: [],
      siteList: [],
      companyList: [],
      columns: machineGroup,
      data: [],
      tableLoading: false,
      pageSizeOpts: [10, 50, 100, 150],
      total: 0,
      machineTypesGroup: [],
      radio: "0",
    };
  },
  async mounted() {
    this.tableLoading = true;
    // this.showDate = [getMonthStart(), new Date()];
    // this.page.start_time = this.$moment(this.showDate[0], "YYYY-MM-DD");
    // this.page.end_time = this.$moment(this.showDate[1], "YYYY-MM-DD");
    this.onChangeSelectData("0");
    //初始化agent
    if (!this.agent.tp) {
      const agentRes = await this.getAgentList({ l: 1000, p: 0, is_del: 0 });
      this.agentList = agentRes.data;
    } else {
      this.page.agent_id = this.agent.id;
    }

    //初始化site
    const siteParams = {
      l: 1000,
      p: 0,
      agent_id: this.agent.tp ? this.agent.id : 0,
      is_del: 0,
    };
    if (!siteParams.agent_id) {
      delete siteParams.agent_id;
    }
    const siteRes = await this.getSite(siteParams);
    this.siteList = siteRes.data;
    //初始化company
    const companyParams = {
      l: 100000,
      p: 0,
      agent_id: this.agent.tp ? this.agent.id : 0,
      is_del: 0,
    };
    if (!companyParams.agent_id) {
      delete companyParams.agent_id;
    }
    const companyRes = await this.getCompany(companyParams);
    this.companyList = companyRes.data;
    //初始化品牌
    this.GetMachineTypeGroup().then((res) => {
      this.machineTypesGroup = res.map((item) => {
        return item.brand;
      });
    });

    this.getData();
  },
  methods: {
    ...mapActions([
      "getAgentList",
      "getSite",
      "getCompany",
      "GetMeterSettlement",
      "GetMachineTypeGroup",

      "GetDataMachine",
      "GetDataCompany",
      "GetDataAgent",
      "GetDataSite",

      "GetPrintStatistics",
    ]),
    handleDateChange(e) {
      this.page.start_time = e[0];
      this.page.end_time = e[1];
    },
    pageChange(p) {
      this.pageInfo.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.pageInfo.l = l;
      this.getData();
    },
    async getData(is_set = 0) {
      /* if (is_set === 1) {
        this.reset();
        return;
      } */
      // this.tableLoading = true;
      //判断当前角度，根据角度获取对应数据
      let data = [],
        params = {
          l: 1000,
          p: 0,
          group: this.page.group,
          start_time: this.page.start_time,
          end_time: this.page.end_time,
          brand: this.pageInfo.brand,
        };
      switch (this.page.group) {
        case "machine_id":
          this.columns = machineGroup;
          await this.GetDataMachine({
            ...this.pageInfo,
            is_del: this.pageInfo.is_del ? 1 : 0,
          }).then((res) => {
            data = res.data;
            this.total = res.total;
          });

          break;
        case "company_id":
          this.columns = companyGroup;
          await this.GetDataCompany({
            ...this.pageInfo,
          }).then((res) => {
            data = res.data;
            this.total = res.total;
          });

          break;
        case "site_id":
          this.columns = siteGroup;
          await this.GetDataSite({
            ...this.pageInfo,
          }).then((res) => {
            data = res.data;
            this.total = res.total;
          });
          break;
      }
      params[this.page.group] = data.map((item) => {
        return item.id;
      });
      // params[this.page.group] =  Array.from(new Set(params[this.page.group]));
      console.log("params", params);
      const resp = await this.GetPrintStatistics(params);
      data.map((item) => {
        item.happed = 0;
        item.mono_happed = 0;
        item.color_happed = 0;
        resp.data.map((val) => {
          if (item.id == val[this.page.group]) {
            item.happed = val.happed;
            item.mono_happed = val.mono_happed;
            item.color_happed = val.color_happed;
          }
        });
      });
      this.data = data;
      this.tableLoading = false;

      /* this.GetMeterSettlement(this.page).then((res) => {
        res.data.map((item) => {
          item.day = this.$moment(item.day, "YYYY-MM-DD");
        });
        this.tableLoading = false;
        this.data = res.data;
        this.total = res.total;
      }); */
    },
    reset() {
      // this.showDate = [getMonthStart(), new Date()];
      // this.page.start_time = this.$moment(this.showDate[0], "YYYY-MM-DD");
      // this.page.end_time = this.$moment(this.showDate[1], "YYYY-MM-DD");

      this.page = {
        l: 10,
        p: 0,
        start_time: "",
        end_time: "",
        brand: [],
        sn: "",
        agent_id: 0,
        site_id: 0,
        company_id: 0,
        group: "machine_id",
      };
      this.onChangeSelectData("0");
      this.radio = "0";
      this.pageInfo = {
        l: 10,
        p: 0,
        search: "",
        brand: [],
        id: 0,
        is_del: 0,
      };
      this.getData();
    },
    handleSwitchAngle(e) {
      this.page = {
        l: 10,
        p: 0,
        start_time: this.page.start_time,
        end_time: this.page.end_time,
        brand: [],
        sn: "",
        agent_id: 0,
        site_id: 0,
        company_id: 0,
        group: e,
      };
      this.pageInfo = {
        l: 10,
        p: 0,
        search: "",
        brand: [],
        id: 0,
        is_del: 0,
      };
      this.getData();
    },
    submit() {
      (this.pageInfo.l = 10), (this.pageInfo.p = 0);
      this.getData();
    },
    onChangeSelectData(e) {
      switch (e) {
        case "0": //今日
          let now = new Date();
          now = now.setDate(now.getDate() - 1);
          this.page.start_time = this.$moment(now, "YYYY-MM-DD");
          this.page.end_time = this.$moment(now, "YYYY-MM-DD");
          this.showDate = [this.page.start_time, this.page.end_time];
          break;
        case "1": //本月
          this.curMonth(true);
          break;
        case "2": //上月
          this.curMonth();
          break;
      }
    },
    curMonth(isCur) {
      let now = new Date();
      let a = isCur ? 1 : 0;
      let last = new Date(now.getFullYear(), now.getMonth() + a, 0);
      this.page.start_time = this.$moment(last, "YYYY-MM") + "-01";
      this.page.end_time = this.$moment(last, "YYYY-MM-DD");
      this.showDate = [this.page.start_time, this.page.end_time];
    },
    async exportData(is_all = 0) {
      let title = ["编号"],
        key = ["id"];

      this.columns.map((item) => {
        title.push(item.title);
        key.push(item.key);
      });

      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "打印统计" + new Date().getTime(),
      };
      this.tableLoading = true;

      if (is_all) {
        /*    this.GetMeterSettlement(page).then((res) => {
          res.data.map((item) => {
            item.day = this.$moment(item.day, "YYYY-MM-DD");
          });
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
          this.tableLoading = false;
        }); */

        //判断当前角度，根据角度获取对应数据
        let data = [],
          dataParams = {
            l: 1000,
            p: 0,
            group: this.page.group,
            start_time: this.page.start_time,
            end_time: this.page.end_time,
            brand: this.pageInfo.brand,
          };
        const comParams = {
          ...this.pageInfo,
        };
        comParams.p = 0;
        comParams.l = this.total;

        switch (this.page.group) {
          case "machine_id":
            this.columns = machineGroup;
            comParams.is_del = this.pageInfo.is_del ? 1 : 0;
            await this.GetDataMachine(comParams).then((res) => {
              data = res.data;
            });

            break;
          case "company_id":
            this.columns = companyGroup;
            await this.GetDataCompany(comParams).then((res) => {
              data = res.data;
            });

            break;
          case "site_id":
            this.columns = siteGroup;
            await this.GetDataSite(comParams).then((res) => {
              data = res.data;
            });
            break;
        }
        dataParams[this.page.group] = data.map((item) => {
          return item.id;
        });
        console.log("params", dataParams);
        const resp = await this.GetPrintStatistics(dataParams);
        data.map((item) => {
          item.happed = 0;
          item.mono_happed = 0;
          item.color_happed = 0;
          resp.data.map((val) => {
            if (item.id == val[this.page.group]) {
              item.happed = val.happed;
              item.mono_happed = val.mono_happed;
              item.color_happed = val.color_happed;
            }
          });
        });

        params.data = this.excelData(data);
        excel.export_array_to_excel(params);
        this.tableLoading = false;
      } else {
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
        this.tableLoading = false;
      }
    },
    // 导出格式化数据
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      return result;
    },
  },
  computed: mapGetters({
    agent: "agent",
  }),
  watch: {},
};
</script>
<style lang="less">
@import "./index.less";
</style>
